import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppService } from 'src/app/app.service';
import { MiniGameService } from 'src/app/pages/minigame/minigame.service';
import { ProviderInterface } from 'src/app/shared/interfaces/game.interface';
import { ImgCarouselOptions } from '../../img-carousel/img-carousel-options.interface';

@Component({
  selector: 'app-swiper-provider-list',
  templateUrl: './swiper-provider-list.component.html',
  styleUrls: ['./swiper-provider-list.component.scss'],
})
export class SwiperProviderListComponent implements OnInit {
  constructor(
    private router: Router,
    private miniGameService: MiniGameService,
    private appService: AppService,
  ) {}

  readonly hideProviderList = ['SoftswissSport'];
  providerList: ProviderInterface[] = [];
  loadinProviderList!: boolean;

  @Input() supplier!: string[]; //需要被过滤的供应商

  providerHref: string = `${this.appService.languageCode}/casino/provider`;

  /**滚动与断点配置 */
  imgCarouselConfig: ImgCarouselOptions = {
    slidesPerView: 7,
    slidesPerGroup: 7,
    spaceBetween: 8,
    speed: 500,
    allowTouchMove: true,
    breakpoints: {
      850: {
        slidesPerView: 4,
        slidesPerGroup: 4,
        spaceBetween: 8,
      },
      500: {
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: 8,
      },
    },
  };

  ngOnInit() {
    this.getProviderList();
  }

  // 获取供应商
  getProviderList() {
    this.loadinProviderList = true;
    this.miniGameService.getAllProvider().subscribe(data => {
      this.loadinProviderList = false;
      if (this.supplier) {
        this.providerList = data.filter(value => this.supplier.includes(value.category));
      } else {
        this.providerList = data;
      }
      // hide 特定 provider
      this.providerList = this.providerList.filter(p => !this.hideProviderList.includes(p.providerId));
    });
  }

  // 点击供应商标题
  clickProviderTitle() {
    this.router.navigateByUrl(this.providerHref);
  }

  // 点击供应商
  clickProviderItem(item: ProviderInterface) {
    if (item.secondaryPage) {
      this.router.navigateByUrl(`${this.appService.languageCode}/casino/provider/${item.providerCatId}`);
    } else {
      // 因為有些供應商沒有二級頁面，所以直接開啟遊戲。 設定 GameId 的預設值為 All
      this.router.navigateByUrl(`${this.appService.languageCode}/play/${item.providerCatId}/All`);
    }
  }
}
